module.exports = __webpack_public_path__ + "imgs/card@1x-min.122b5644.webp";